export default "__VITE_ASSET__53cb58af__"